import gql from 'graphql-tag';
import apollo from '../apollo';

export const ADD_TEAM_REPORT_MUTATE = gql`
  mutation createTeamReport($input: CreateTeamReportInput!) {
    createTeamReport(input: $input) {
      id
      teamName
    }
  }
`;

export const createTeamReport = input => apollo
  .mutate({
    mutation: ADD_TEAM_REPORT_MUTATE,
    variables: {
      input,
    },
  })
  .then(res => res.data);

export const UPDATE_TEAM_REPORT = gql`
  mutation($input: UpdateTeamReportDetailsInput!) {
    updateTeamReportDetails(input: $input) {
      id
      teamName
      numberOfAssessments
    }
  }
`;

export const updateTeamReport = input => apollo
  .mutate({
    mutation: UPDATE_TEAM_REPORT,
    variables: {
      input,
    },
  })
  .then(res => res.data);

export const UPDATE_TEAM_REPORT_ASSESSMENTS = gql`
  mutation($input: UpdateTeamReportAssessmentsInput!) {
    updateTeamReportAssessments(input: $input) {
      id
      teamName
      numberOfAssessments
    }
  }
`;

export const updateTeamReportAssessments = input => apollo
  .mutate({
    mutation: UPDATE_TEAM_REPORT_ASSESSMENTS,
    variables: {
      input,
    },
    refetchQueries: ['getTeamReportAssessments'],
  })
  .then(res => res.data);

export const DELETE_TEAM_REPORT = gql`
  mutation($input: DeleteTeamReportInput!) {
    deleteTeamReport(input: $input) {
      accountId
    }
  }
`;

export const deleteTeamReport = input => apollo
  .mutate({
    mutation: DELETE_TEAM_REPORT,
    variables: {
      input,
    },
  })
  .then(res => res.data);
